// These are the Code values in codeRepValues (Category = 'CorrectionRequest'), not row IDs —
// the numeric Id for each status is environment-specific and must be looked up dynamically
// (see CorrectionsTab.jsx's correctionStatuses, fetched via getRefValues) instead of hardcoded.
export const CORRECTION_STATUS = {
  OPEN: 'Open',
  RESOLVED: 'Resolved',
  IN_PROGRESS: 'In Progress',
  CLOSE: 'Close',
};
